module.exports = __webpack_public_path__ + "img/changeProfile-1@2x.4f2518b.webp";